import { RouteType } from "types/RouteType";
import type { RootStore } from "stores/index";
import InvoicesStore from "./Invoices.Store";

/**
 * Invoices Route
 *
 * Main invoice management view per spec 06-invoice-management.md
 * - Invoice list with type filtering (IM-06)
 * - Create/edit dialogs
 * - Duplicate detection (IM-01)
 * - Direct-to-GL support (IM-03)
 */
const invoicesRoute: RouteType = {
  name: "Invoices",
  path: "/accounting/invoices",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Invoices",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./Invoices.Header"),
    },
    body: {
      component: () => import("./Invoices.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).invoiceManagementStore as InvoicesStore;
    if (store) {
      await store.loadInvoices();
    }
    return true;
  },
  onParamsChange: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).invoiceManagementStore as InvoicesStore;
    if (store) {
      await store.loadInvoices();
    }
  },
  dialogs: [
    {
      name: "createInvoice",
      title: "Create Invoice",
      component: () => import("./dialogs/CreateInvoiceDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        // Handle invoice creation
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const store = (rootStore as any).invoiceManagementStore as InvoicesStore;
        const validation = store?.validateInvoice(store.formData);
        return !validation?.isValid;
      },
      cancelButton: true,
      height: 700,
    },
    {
      name: "invoiceDetail",
      title: "Invoice Details",
      component: () => import("./dialogs/InvoiceDetailDialog.Body"),
      cancelButton: true,
      height: 650,
    },
    {
      name: "directToGL",
      title: "Journal Entry",
      component: () => import("./dialogs/DirectToGLDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        // Handle journal entry submission
      },
      cancelButton: true,
      height: 600,
    },
    {
      name: "voidInvoice",
      title: "Void Invoice",
      component: () => import("./dialogs/VoidInvoiceDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        // Handle void invoice submission
      },
      cancelButton: true,
      height: 300,
    },
  ],
};

export default invoicesRoute;
